import axios from "axios";

const API = axios.create({
  baseURL: "https://api.ilogically.com/api/notification"
});

export const getLogs = (params) =>
  API.get("/logs", { params });
